import { useRef, useEffect, useState } from 'react'
import { TextureLoader, sRGBEncoding } from 'three'
import { useFrame } from '@react-three/fiber';
import Cocacentered from './objects/cocacentered';
import { useSpring } from '@react-spring/three';

const LabelPreviewer = ({ labelController, ...props }) => {

    const textureLoaderRef = useRef(new TextureLoader());
    const canOverrideRef = useRef({
        map: null,
        position: [0, 0, 0],
        opacity: 1,
        disableAnimation: true,
    });

    const [{shake}, shakeAPI] = useSpring(() => ({ shake: 0.5 }))

    function animateShake() {
        shakeAPI.start({
            to: [{ shake: 1 }, { shake: 0.3 }, { shake: 0.5}],
            config: { duration: 40 }
        });
    }

    let selectedObject = "can";

    const objectPositions = {
        can: [0, 0, 0],
    }

    function setPositions() {
        const shakeOffset = shake.get() * 0.1;
        objectPositions.can = [0.0 + shakeOffset * 0.5, 0 + (selectedObject === "can" ? 0 : 20) + shakeOffset, 0];
    }

    useEffect(() => {
        // Set up the label controller to allow updating the texture
        labelController.updateTexture = (imageUrl) => {
            if (imageUrl) {
                const newTexture = textureLoaderRef.current.load(imageUrl);
                newTexture.encoding = sRGBEncoding;
                newTexture.flipY = false;
                canOverrideRef.current.map = newTexture;
            }
        };
        labelController.isReady = true;
    }, []);

    useFrame(() => {
        setPositions();
        canOverrideRef.current.position = objectPositions.can;
    });

    return (
        <group position={props.position} rotation={[-0.1, 0.5, 0]} scale={1.3}>
            <group position={[0, -0.2, 0]}>
                <Cocacentered scale={0.7} override={canOverrideRef.current} />
            </group>
        </group>
    )
}

export default LabelPreviewer;
